<div class="dialog">
  <div class="row">
    <div class="col-md-6">
      <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
    </div>
    <div class="col-md-6 align-right">
      <button
        type="button"
        class="btn btn-xs btn-success"
        (click)="addLocation()"
        *ngIf="listMode && permissions.canCreate"
      >
        <i class="fa fa-plus"></i> {{ 'ADD_LOCATION' | translate }}
      </button>
      <button type="button" class="btn btn-xs" (click)="showLocations()" *ngIf="detailMode">
        <i class="fa fa-angle-left"></i> {{ 'BACK' | translate }}
      </button>

      <span class="dialog-close" (click)="close()">
        <i class="fa fa-close"></i>
      </span>
    </div>
  </div>

  <div class="dialog-content">
    <div *ngIf="listMode">
      <div *ngIf="permissions.canList">
        <app-location-list
          [locations]="locations"
          [meta]="meta"
          [loadingLocations]="loadingLocations"
          [defaultLanguage]="defaultLanguage"
          (selectedLocation)="onSelectedLocation($event)"
        ></app-location-list>
      </div>
      <div *ngIf="!permissions.canList">INVALID ACCESS</div>
    </div>

    <div *ngIf="detailMode">
      <app-spinner *ngIf="!location"></app-spinner>
      <div *ngIf="location">
        <app-location-detail
          [location]="location"
          [mode]="mode"
          [defaultLanguage]="defaultLanguage"
          [additionalLanguages]="additionalLanguages"
          [isModal]="true"
          (savedLocation)="onSavedLocation($event)"
          (canceledLocation)="onCanceledLocation()"
        ></app-location-detail>
      </div>
    </div>
  </div>
</div>
